import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SwitchHorizontalIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SwitchHorizontalGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <circle cx="12.8098" cy="12" r="10" fill="white" />
      <path
        d="M2.80981 12C2.80981 6.48584 7.29614 2 12.8098 2C18.3235 2 22.8098 6.48584 22.8098 12C22.8098 17.5142 18.3235 22 12.8098 22C7.29614 22 2.80981 17.5142 2.80981 12ZM21.8098 12C21.8098 7.0376 17.7727 3 12.8098 3C7.84692 3 3.80981 7.0376 3.80981 12C3.80981 16.9624 7.84692 21 12.8098 21C17.7727 21 21.8098 16.9624 21.8098 12Z"
        fill="#696969"
      />
      <path
        d="M8.62035 14.4736C8.62035 14.1973 8.84398 13.9736 9.12035 13.9736L16.762 13.9736C17.0383 13.9736 17.262 14.1973 17.262 14.4736C17.262 14.75 17.0383 14.9736 16.762 14.9736L9.12035 14.9736C8.84398 14.9736 8.62035 14.75 8.62035 14.4736Z"
        fill="#696969"
      />
      <path
        d="M14.3782 16.5391C14.3782 16.4184 14.4211 16.2979 14.509 16.2021L16.0852 14.4736L14.509 12.7436C14.3215 12.5391 14.3372 12.2236 14.5413 12.0371C14.7454 11.8511 15.0618 11.8657 15.2473 12.0698L17.1311 14.1367C17.3049 14.3281 17.3049 14.6201 17.1311 14.8105L15.2473 16.876C15.0618 17.0801 14.7454 17.0947 14.5413 16.9087C14.4329 16.81 14.3782 16.6748 14.3782 16.5391Z"
        fill="#696969"
      />
      <path
        d="M8.62035 9.52637C8.62035 9.25 8.84398 9.02637 9.12035 9.02637L16.762 9.02637C17.0383 9.02637 17.262 9.25 17.262 9.52637C17.262 9.80274 17.0383 10.0264 16.762 10.0264L9.12035 10.0264C8.84398 10.0264 8.62035 9.80274 8.62035 9.52637Z"
        fill="#696969"
      />
      <path
        d="M8.62035 9.52637C8.62035 9.40576 8.6643 9.28467 8.75121 9.18946L10.635 7.12403C10.8206 6.91993 11.137 6.90528 11.3411 7.09132C11.5461 7.27687 11.5598 7.59425 11.3733 7.79786L9.79711 9.52638L11.3733 11.2559C11.5588 11.46 11.5452 11.7764 11.3411 11.9624C11.1369 12.1484 10.8205 12.1338 10.635 11.9297L8.75121 9.86329C8.6643 9.76759 8.62035 9.64697 8.62035 9.52637Z"
        fill="#696969"
      />
    </svg>
  );
};

export default SwitchHorizontalIcon;
